// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cIUgc","right":"styles_right__6XgNI"};